/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const systemRoutes = [
  {
    path: "system",
    canActivateChild: [isLoggedIn, hasUserTypes(UserAccountType.Admin)],
    children: [
      {
        path: "sql-export",
        children: [
          {
            path: "",
            loadComponent: () => import("./sql-exports/sql-exports-form").then(m => m.SqlExportsForm),
          },
        ],
      },
    ],
  },
] as const satisfies Routes;
